export default "__VITE_ASSET__D5e3DhAo__"